import Errors from "../../shared/errors";

function OwnedFilms(props) {
    const {
        films,
        unDeleteFilm
    } = props;


    return (
        <>
            <h2 className="menu-label">Owned Films</h2>
            <table className="table">
                <tr>
                    <th>Name</th>
                    <th>Modified</th>
                    <th>Deleted</th>
                </tr>

                {(films || []).map((film) =>
                    <tr>
                        <td>{film.name}</td>
                        <td>{film.lastModified}</td>
                        <td>{film.deleted ? "Yes" : "No"} {film.deleted && <button className="button" onClick={() => unDeleteFilm(film)}>Un Delete</button>}</td>
                    </tr>)}

            </table>
        </>
    );
}

export default OwnedFilms
